export const extractCompanyIdFromSlug = (
  input?: string,
): string | undefined => {
  if (!input) {
    return undefined;
  }
  const parts = input.split('-');
  return parts.length > 1 ? parts[parts.length - 1] : undefined;
};
